module.exports = __webpack_public_path__ + "img/page18.46b324fe.jpg";